import * as Parse from 'parse';
import { FileModel, HashTagModel, MetaImage, StringModel, VideoModel } from '.';
import { ModelDecorator } from '../decorators';

export default class Post extends Parse.Object {

    @ModelDecorator.Variable
    public title: StringModel;

    @ModelDecorator.Variable
    public description: StringModel;

    @ModelDecorator.Variable
    public image: FileModel;

    @ModelDecorator.Variable
    public video: VideoModel;

    @ModelDecorator.Variable
    public content: StringModel;

    @ModelDecorator.Variable
    public keywords: StringModel;

    @ModelDecorator.Variable
    public date: Date;

    @ModelDecorator.Variable
    public published: boolean;

    @ModelDecorator.Variable
    public metaImages: MetaImage;

    @ModelDecorator.Relation
    public hashtags: Parse.Relation<HashTagModel, HashTagModel>;

    public unsavedHashTags: HashTagModel[];
    public selectedHashTags: HashTagModel[] | any[];

    constructor() {
        super('Post');
        this.unsavedHashTags = [];
        this.selectedHashTags = [];
        this.title = new StringModel();
        this.description = new StringModel();
        this.image = new FileModel();
        this.image.alt = new StringModel();
        this.keywords = new StringModel();
        this.video = new VideoModel();
        this.video.alt = new StringModel();
        this.video.url = new StringModel();
        this.content = new StringModel();
        this.published = false;
        this.metaImages = new MetaImage();
    }

    // tslint:disable-next-line:member-ordering
    public static async getPostsCount() {
        return new Parse.Query(Post).count()
    }

    // tslint:disable-next-line:member-ordering
    public static async searchPosts(s: string, limit: number, skip: number, isCount = false) {
        const stringQuery = new Parse.Query(StringModel);
        stringQuery.matches('ru', new RegExp(s, 'i'), null);
        const searchQuery = new Parse.Query(Post)
        searchQuery.descending('date')
        searchQuery.include(['title'])
        searchQuery.matchesQuery('title', stringQuery)
        if (isCount) {
            return searchQuery.count();
        } else {
            searchQuery.limit(limit);
            searchQuery.skip(skip);
            return searchQuery.find();
        }
    }

    // tslint:disable-next-line:member-ordering
    public static async deleteAllPosts(posts: Post[]) {
        const subobjectForDelete: any[] = [];
        const mainobjectForDelete: any[] = [];
        posts.forEach((p) => {
            subobjectForDelete.push(p.title);
            if (p.video) {
                if (p.video.url) {
                    subobjectForDelete.push(p.video.url);
                }
                if (p.video.alt) {
                    subobjectForDelete.push(p.video.alt);
                }
                mainobjectForDelete.push(p.video);
            }
            if (p.image.alt) {
                subobjectForDelete.push(p.image.alt);
            }
            subobjectForDelete.push(p.content);
            mainobjectForDelete.push(p.image);
            mainobjectForDelete.push(p);
        })
        await Post.destroyAll(subobjectForDelete);
        await Post.destroyAll(mainobjectForDelete);
    }

    // tslint:disable-next-line:member-ordering
    public static async loadPosts(skip = 0, limit = 25) {
        return new Parse.Query(Post)
            .descending('date')
            .include(['title'])
            .limit(limit)
            .skip(skip)
            .find()
    }

    // tslint:disable-next-line:member-ordering
    public static async loadPost(postId: string) {
        const postQuery = await new Parse.Query(Post);
        postQuery.include(['title', 'description', 'image', 'video', 'content', 'metaImages','keywords']);
        const post = await postQuery.get(postId);
        post.image.alt = post.image.alt ? await post.image.alt.fetch() : new StringModel();
        post.video.url = post.video.url ? await post.video.url.fetch() : new StringModel();
        post.video.alt = post.video.alt ? await post.video.alt.fetch() : new StringModel();
        post.selectedHashTags = await post.hashtags.query().find();
        post.selectedHashTags = (post.selectedHashTags as HashTagModel[]).map(e => ({ label: e.name, value: e.id }));
        return post;
    }

    public async saveFullPost() {
        if (this.id) {
            const existedHashtags = await this.hashtags.query().find();
            if (existedHashtags.length) {
                this.hashtags.remove(existedHashtags)
                await this.save();
            }
        }
        await this.title.save();
        await this.description.save();
        if (this.video) { await this.video.save() }
        if (this.video.alt) { await this.video.alt.save() }
        if (this.video.url) { await this.video.url.save() }
        for (const uH of this.unsavedHashTags) {
            const sH = await uH.save();
            this.hashtags.add(sH);
        }
        for (let sH of this.selectedHashTags) {
            sH = await HashTagModel.getHashTag(sH['value']);
            this.hashtags.add(sH);
        }
        if (this.metaImages && (this.metaImages.fb || this.metaImages.vk || this.metaImages.twitter)) { await this.metaImages.save() }
        if (this.image) { await this.image.save() }
        if (this.image.alt) { await this.image.alt.save() }
        if (this.image.ru && !this.image.ru.url) { await this.image.ru.save(); }
        if (this.image.en) { await this.image.en.save(); }
        if (!this.date) {
            this.date = new Date();
        }
        await this.save();
    }
}

Parse.Object.registerSubclass('Post', Post);


// WEBPACK FOOTER //
// ./src/models/Post.ts